import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Layout } from 'antd';
import { Link } from 'react-router-dom';

const { Footer } = Layout;
// LandingFooter component;
class LandingFooter extends Component {
  render() {
    return (
      <Footer className="landing__footer">
        <div className="container">
          <Row className="landing__footer--links" type="flex">
            <Col xs={24} sm={24} md={20} lg={16}>
              {/* <Row type="flex">
                <Col className="landing__footer--link">
                  <p>
                    <Link to="/contact">
                      <FormattedMessage
                        id="landing.footer.contacts"
                        defaultMessage="Contacts"
                        description="Footer contacts link"
                      />
                    </Link>
                  </p>
                  <p>
                    <Link to="/solution">
                      <FormattedMessage
                        id="landing.footer.solution"
                        defaultMessage="Solutions"
                        description="Footer solution link"
                      />
                    </Link>
                  </p>
                  <p>
                    <Link to="/leads">
                      <FormattedMessage
                        id="landing.footer.leads"
                        defaultMessage="Verification leads"
                        description="Footer verification leads link"
                      />
                    </Link>
                  </p>
                  <p>
                    <Link to="/antifrood">
                      <FormattedMessage
                        id="landing.footer.antifrood"
                        defaultMessage="Anti-fraud"
                        description="Footer antifrood link"
                      />
                    </Link>
                  </p>
                  <p>
                    <Link to="/client-path">
                      <FormattedMessage
                        id="landing.footer.road"
                        defaultMessage="Client path"
                        description="Footer client path link"
                      />
                    </Link>
                  </p>
                </Col>
                <Col className="landing__footer--link">
                  <p>
                    <Link to="/for">
                      <FormattedMessage id="landing.footer.for" defaultMessage="For" description="Footer for link" />
                    </Link>
                  </p>
                  <p>
                    <Link to="/for-advertisers">
                      <FormattedMessage
                        id="landing.footer.for-advertisers"
                        defaultMessage="For advertisers"
                        description="Footer for advertisers link"
                      />
                    </Link>
                  </p>
                  <p>
                    <Link to="/for-partner-networks">
                      <FormattedMessage
                        id="landing.footer.for-partner-networks"
                        defaultMessage="For partner networks"
                        description="Footer for partner networks link"
                      />
                    </Link>
                  </p>
                  <p>
                    <Link to="/for-advertising-agencies">
                      <FormattedMessage
                        id="landing.footer.for-advertising-agencies"
                        defaultMessage="For advertising agencies"
                        description="Footer for advertising agencies link"
                      />
                    </Link>
                  </p>
                </Col>
              </Row> */}
            </Col>
          </Row>
          <Row className="landing__footer--copyright" type="flex">
            <FormattedMessage
              id="landing.footer.copyright"
              defaultMessage="Copyright © 2017–{year} Conduster. All rights reserved"
              description="Footer copyright"
              values={{ year: new Date().getFullYear() }}
            />
          </Row>
        </div>
      </Footer>
    );
  }
}

export default LandingFooter;



// WEBPACK FOOTER //
// ./src/components/landing/common/Footer.js